import React, { useState } from "react";
import PropTypes from "prop-types";
import Button from "@mui/material/Button";
import { styled } from "@mui/material/styles";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import { Stack } from "@mui/material";
import { IoClose } from "react-icons/io5";
import TextField from "@mui/material/TextField";
import { useDispatch, useSelector } from "react-redux";
import { addUser } from "../Redux/UserMaintanence";
import './AddUser.css';
import UserAutoComplete from "./UserAutoComplete";
const BootstrapDialog = styled(Dialog)(({
  theme
}) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2)
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1)
  }
}));
function BootstrapDialogTitle(props) {
  const {
    children,
    onClose,
    ...other
  } = props;
  return <DialogTitle sx={{
    m: 0,
    p: 2
  }} {...other}>
      {children}
      {onClose ? <IconButton aria-label="close" onClick={onClose} sx={{
      position: "absolute",
      right: 0,
      top: 0,
      color: theme => theme.palette.grey[500]
    }}>
          {/* <CloseIcon /> */}
          <img src="images/Home/close_img.png" alt="icon" className="form_close_img" />
        </IconButton> : null}
    </DialogTitle>;
}
BootstrapDialogTitle.propTypes = {
  children: PropTypes.node,
  onClose: PropTypes.func.isRequired
};
const ColorButton = styled(Button)(({
  theme
}) => ({
  color: theme.palette.getContrastText("#7500C0"),
  backgroundColor: "#7500C0",
  "&:hover": {
    backgroundColor: "#7500C0",
    color: "#fff"
  }
}));
function AddUser(props) {
  const tracks = useSelector(state => state?.track?.data);
  const activetracks = tracks.filter(track => track.isActive);
  const dispatch = useDispatch();
  const [newUser, setNewUser] = useState(null);
  const [error, setError] = useState(false);
  const [userRolesCB, setUserRolesCB] = useState({
    designer_cb: false,
    requestor_cb: false,
    approver_cb: false,
    admin_cb: false
  });
  const [isDuplicateUser, setIsDuplicateUser] = useState(false);
  const [isUserAddedSuccess, setIsUserAddedSuccess] = useState(false);
  const [selectedTrack, setSelectedTrack] = useState('');
  const [trackOtherVal, setTrackOtherVal] = useState('');
  const [trackValidMsg, setTrackValidMsg] = useState('');
  const handleTrackChange = event => {
    setSelectedTrack(event.target.value);
    event.target.value !== '' && setTrackValidMsg('');
  };
  function handleOtherTrackVal(e) {
    setTrackOtherVal(e.target.value);
    e.target.value !== '' && setTrackValidMsg('');
  }
  const handleUserRolesCB = event => {
    const {
      name,
      checked
    } = event.target;
    setUserRolesCB(prevState => ({
      ...prevState,
      'designer_cb': name === 'designer_cb' ? checked === true ? true : false : name === 'admin_cb' ? checked === true ? true : userRolesCB.designer_cb : userRolesCB.designer_cb,
      'requestor_cb': name === 'requestor_cb' ? checked === true ? true : false : name === 'approver_cb' ? checked === true ? true : userRolesCB.requestor_cb : name === 'admin_cb' ? checked === true ? true : userRolesCB.requestor_cb : userRolesCB.requestor_cb,
      'approver_cb': name === 'approver_cb' ? checked === true ? true : false : name === 'admin_cb' ? checked === true ? true : userRolesCB.approver_cb : name === 'requestor_cb' ? checked === true ? false : false : userRolesCB.approver_cb,
      'admin_cb': name === 'admin_cb' ? checked === true ? true : false : name === 'approver_cb' ? checked === true ? false : false : name === 'requestor_cb' ? checked === true ? false : false : userRolesCB.admin_cb
    }));
  };
  const handleClose = () => {
    props.setOpenEdit(false);
    setNewUser("");
    setSelectedTrack('');
    setTrackOtherVal('');
    setIsDuplicateUser(false);
    setIsUserAddedSuccess(false);
    setUserRolesCB({
      designer_cb: false,
      requestor_cb: false,
      approver_cb: false,
      admin_cb: false
    });
  };
  function handleSelectedUser(email) {
    setNewUser(email);
    setError(false);
  }
  const saveAddHandle = () => {
    if (!newUser) {
      setError(true);
    }
    if (newUser !== '' && selectedTrack === '') {
      setTrackValidMsg('Please select track');
      return;
    }
    if (newUser != "") {
      if (props.initData.some(item => item.Enterprise_ID === newUser)) {
        setIsDuplicateUser(true);
      } else {
        dispatch(addUser(newUser, selectedTrack, userRolesCB));
        setNewUser("");
        setIsUserAddedSuccess(true);
      }
      setUserRolesCB({
        designer_cb: false,
        requestor_cb: false,
        approver_cb: false,
        admin_cb: false
      });
    }
  };
  let dialogHeaderStyle = {
    fontSize: "16px",
    fontWeight: "600",
    textAlign: "center",
    paddingBottom: "0px !important"
  };
  return <BootstrapDialog onClose={(event, reason) => {
    if (reason !== 'backdropClick' && reason !== 'escapeKeyDown') {
      handleClose();
    }
  }} aria-labelledby="customized-dialog-title" open={props.openEdit}>
      <BootstrapDialogTitle id="customized-dialog-title" className="popup" sx={dialogHeaderStyle}>
        <span className="add_user_heading">Add User</span>
        <span onClick={handleClose} className="migrated-style-adduser-d038aa-1"><IoClose /></span>
      </BootstrapDialogTitle>
      {!isDuplicateUser && !isUserAddedSuccess ? <DialogContent sx={{
      paddingTop: "15px",
      width: "450px"
    }}>
          <Stack sx={{
        padding: "5px 30px 10px 30px",
        marginTop: "10px"
      }} spacing={2}>
            <Stack spacing={1}>
              <Typography sx={{
            fontSize: "14px",
            color: "#000000"
          }}>
                <span className="add_user_field_heading">Enterprise ID</span> <span className="migrated-style-adduser-d038aa-2">*</span>
              </Typography>              
              <UserAutoComplete onUserselect={handleSelectedUser} error={error} />
              <div className="adduser_track_section">
                <p className="adduser_track_heading">
                  <span className="add_user_field_heading">Select Track</span>
                  <span className="adduser_track_validation_asterisk">&nbsp;*</span>
                  {trackValidMsg !== '' && <span className="adduser_track_error_msg">({trackValidMsg})</span>}
                </p>
                <select className='adduser_track_select' value={selectedTrack} onChange={handleTrackChange}>
                  <option value="">Select...</option>
                  {activetracks?.map(track => <option value={track.id}>{track.title}</option>)}                   
                  
                </select>
                {selectedTrack === 'Others' && <input type="text" value={trackOtherVal} onChange={handleOtherTrackVal} className="adduser_track_input" />}
              </div>

              <Typography sx={{
            fontSize: "15px",
            color: "#000000"
          }}>
                <span className="add_user_field_heading">Select Roles</span> <span className="migrated-style-adduser-d038aa-3"></span>
              </Typography>
              <div className="roles_checkboxes_container">
                <div className="role_checkbox">
                  <input type="checkbox" name="designer_cb" onChange={handleUserRolesCB} checked={userRolesCB.designer_cb} />
                  <span className="role_checkbox_label">Designer</span>
                </div>
                <div className="role_checkbox">
                  <input type="checkbox" name="requestor_cb" onChange={handleUserRolesCB} checked={userRolesCB.requestor_cb} />
                  <span className="role_checkbox_label">Requestor</span>
                </div>
                <div className="role_checkbox">
                  <input type="checkbox" name="approver_cb" onChange={handleUserRolesCB} checked={userRolesCB.approver_cb} />
                  <span className="role_checkbox_label">Approver</span>
                </div>
                <div className="role_checkbox">
                  <input type="checkbox" name="admin_cb" onChange={handleUserRolesCB} checked={userRolesCB.admin_cb} />
                  <span className="role_checkbox_label">Admin</span>
                </div>
              </div>

            </Stack>
          </Stack>

        </DialogContent> : isUserAddedSuccess && !isDuplicateUser ? <DialogContent sx={{
      paddingTop: "15px",
      paddingBottom: "15px",
      width: "450px"
    }}>
          <Stack sx={{
        padding: "10px",
        marginTop: "10px"
      }} spacing={2}></Stack>
          <Typography sx={{
        fontSize: "14px",
        textAlign: "center"
      }}>
            User Added Successfully!
          </Typography>
        </DialogContent> : <DialogContent sx={{
      paddingTop: "15px",
      paddingBottom: "15px",
      width: "450px"
    }}>
          <Stack sx={{
        padding: "10px",
        marginTop: "10px"
      }} spacing={2}></Stack>
          <Typography sx={{
        fontSize: "14px",
        textAlign: "center"
      }}>
            The user has already got access!
          </Typography>
        </DialogContent>}
      {!isDuplicateUser && !isUserAddedSuccess ? <DialogActions sx={{
      justifyContent: "center",
      alignItems: "center",
      marginBottom: "20px"
    }}>
          <ColorButton variant="contained" className="save-button" size="small" sx={{
        "background-color": "white",
        "color": "black",
        "border": "1px solid blueviolet",
        "border-radius": "18px",
        "text-transform": "capitalize",
        "padding": "5px 20px",
        "font-weight": "600",
        "font-size": "14px"
      }} autoFocus onClick={saveAddHandle}>
            Submit
          </ColorButton>
          <ColorButton variant="contained" className="cancel-button" size="small" sx={{
        "background-color": "white",
        "color": "black",
        "border": "1px solid blueviolet",
        "border-radius": "18px",
        "text-transform": "capitalize",
        "padding": "5px 20px",
        "font-weight": "600",
        "font-size": "14px"
      }} autoFocus onClick={handleClose}>
            Cancel
          </ColorButton>
        </DialogActions> : <DialogActions sx={{
      justifyContent: "center",
      alignItems: "center",
      marginBottom: "10px"
    }}>
          <ColorButton variant="contained" className="cancel-button" size="small" sx={{
        background: "white",
        color: "#7500C0",
        border: "solid 1px #7500C0"
      }} autoFocus onClick={handleClose}>
            Ok
          </ColorButton>
        </DialogActions>}
    </BootstrapDialog>;
}
export default AddUser;
